/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { IErrorAdapter } from './IErrorAdapter';
import { NormalizedError } from './NormalizedError';

/**
 * Adapter for Axios HTTP client errors.
 */
export class AxiosErrorAdapter implements IErrorAdapter {
    // eslint-disable-next-line class-methods-use-this
    public normalizeError(error: any): NormalizedError {
        if (!error) {
            return {
                isNetworkError: false,
            };
        }

        // Network errors: Have error.code but NO response
        if (error.code && !error.response) {
            return {
                code: error.code,
                isNetworkError: true,
            };
        }

        // API errors: Have response with status and optional error code
        if (error.response) {
            return {
                code: error.code,
                isNetworkError: false,
                response: {
                    status: error.response.status,
                    data: error.response.data,
                },
            };
        }

        // Fallback: Unknown error structure
        return {
            code: error.code,
            isNetworkError: false,
        };
    }
}
